import { createReducer, on } from '@ngrx/store';
import { PackageTableState } from './package-table.state';
import {
    packageTableChangePage,
    packageTableChangeQuery,
    packageTableFailure, packageTableMasterToggle,
    packageTableRequest, packageTableSetSelection, packageTableSort,
    packageTableSuccess, packageTableToggle
} from './package-table.actions';

const initialState: PackageTableState = {
    query: {
        sortColumn: 'description',
        sortDescending: false,
        pageNumber: 1,
        itemsPerPage: 25,
        description: null
    },
    page: [],
    totalCount: null,
    filteredCount: null,
    busy: false,
    error: false,
    selection: []
};

const reducer = createReducer(
    initialState,
    on(packageTableRequest, (state) => ({
        ...state,
        busy: true,
        error: false
    })),
    on(packageTableSuccess, (state, { totalCount, page }) => ({
        ...state,
        busy: false,
        page,
        totalCount,
        error: false
    })),
    on(packageTableFailure, (state) => ({
        ...state,
        busy: false,
        error: true,
    })),
    on(packageTableRequest, (state) => ({
        ...state,
        busy: true,
        error: false
    })),
    on(packageTableChangePage, (state, { pageNumber, itemsPerPage }) => ({
        ...state,
        selection: [],
        query: { ...state.query, pageNumber, itemsPerPage }
    })),
    on(packageTableChangeQuery, (state, { query }) => ({
        ...state,
        query
    })),
    on(packageTableSort, (state, { id, descending }) => ({
        ...state,
        query: { ...state.query, sortColumn: id, sortDescending: descending }
    })),
    on(packageTableSetSelection, (state, { selection }) => ({
        ...state,
        selection
    })),
    on(packageTableToggle, (state, { id }) => ({
        ...state,
        selection: state.selection.indexOf(id) === -1 ? [ ...state.selection, id ] : state.selection.filter((sid) => sid !== id)
    })),
    on(packageTableMasterToggle, (state) => ({
        ...state,
        selection: state.selection.length === 0 ? state.page.map(h => h.id) : []
    }))
);

export function packageTableReducer(state: PackageTableState | undefined, action: any): any {
    return reducer(state, action);
}
